import { ai2htmlResize } from './utils/ai2html-resizer';

ai2htmlResize('#g-la-perrys-peak-avalanche-box');
